import React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import Edit from '@material-ui/icons/Edit';

const styles = theme => ({
  link: {
    display: 'inline-flex',
    textDecoration: 'none',

    '&:focus': {
      background: 'inherit',
      color: 'inherit',
    },
  },
  editColor: {
    color: theme.palette.text.primary,
    textTransform: 'uppercase',

    [theme.breakpoints.up('sm')]: {
      color: theme.palette.secondary.main,
    }
  },
  editColorAlert: {
    color: 'white',
    textTransform: 'uppercase',
  },
  editIcon: {
    marginRight: theme.spacing(0.5),
  },
})

const EditLink = ({
  t,
  classes: c,
  path,
  hasAlerts,
  isSmallScreen,
}) => {
  const editColor = hasAlerts  && isSmallScreen ? c.editColorAlert : c.editColor;

  return (
    <Link to={path} className={c.link}>
      <Edit className={classNames(c.editIcon, editColor)} />
    </Link>
  )
}

export default withStyles(styles)(EditLink)



// WEBPACK FOOTER //
// ./src/components/Jobs/Job/EditLink/EditLink.js